import styled from 'styled-components';
import { colors } from '../../../defaultTheme';
export const CarouselWrapper = styled.div `
  width: 100%;
  position: relative;
  margin: auto;
  display: flex;
`;
export const SlideWrapper = styled.div `
  width: 100%;
  display: flex;
  display: ${({ isActiveSlide }) => (isActiveSlide ? 'flex' : 'none')};
  margin: 0 auto;
  justify-content: center;
`;
export const DotWrapper = styled.div `
  text-align: center;
`;
export const Dot = styled.button `
  cursor: pointer;
  height: 12px;
  width: ${({ isActiveSlide }) => (isActiveSlide ? '12px' : '10px')};
  background-color: ${({ isActiveSlide }) => isActiveSlide ? colors.heavyGrey : colors.lightGrey};
  border-radius: 50%;
  display: inline-block;
  &:active,
  &:hover {
    background-color: ${({ isActiveSlide }) => isActiveSlide ? colors.heavyGrey : colors.lightGrey};
  }
  border: none;
  padding: 0px;
`;
